import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=cb6b5c76&scoped=true&"
import script from "./CustomReport.vue?vue&type=script&lang=ts&"
export * from "./CustomReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b5c76",
  null
  
)

export default component.exports